import { render, staticRenderFns } from "./HNews.vue?vue&type=template&id=4f8527be&scoped=true&"
import script from "./HNews.vue?vue&type=script&lang=js&"
export * from "./HNews.vue?vue&type=script&lang=js&"
import style0 from "./HNews.vue?vue&type=style&index=0&id=4f8527be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8527be",
  null
  
)

export default component.exports